"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnstyledButton = (
/*#__PURE__*/
0, _styledBase.default)('button', {
  target: "e1fx5zrq0"
})("background:transparent;border:none;box-shadow:none;padding:0;width:100%;text-align:inherit;font-size:inherit;font-family:inherit;white-space:normal;&:hover{background-color:transparent;box-shadow:none;cursor:", function (props) {
  return props.disabled ? 'default' : 'pointer';
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jbGlja2FibGUvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3VDIiwiZmlsZSI6Ii4uLy4uL3NyYy9jbGlja2FibGUvaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjb21wb3NlLCBzZXREaXNwbGF5TmFtZSwgc2V0UHJvcFR5cGVzLCB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCByZXF1aXJlZElmIGZyb20gJ3JlYWN0LXJlcXVpcmVkLWlmJztcblxuY29uc3QgVW5zdHlsZWRCdXR0b24gPSBzdHlsZWQoJ2J1dHRvbicpYFxuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgYm9yZGVyOiBub25lO1xuICBib3gtc2hhZG93OiBub25lO1xuICBwYWRkaW5nOiAwO1xuICB3aWR0aDogMTAwJTtcbiAgdGV4dC1hbGlnbjogaW5oZXJpdDtcbiAgZm9udC1zaXplOiBpbmhlcml0O1xuICBmb250LWZhbWlseTogaW5oZXJpdDtcbiAgd2hpdGUtc3BhY2U6IG5vcm1hbDtcblxuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICBib3gtc2hhZG93OiBub25lO1xuICAgIGN1cnNvcjogJHtwcm9wcyA9PiBwcm9wcy5kaXNhYmxlZCA/ICdkZWZhdWx0JyA6ICdwb2ludGVyJ307XG4gIH1cbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbXBvc2UoXG4gIHNldFByb3BUeXBlcyh7XG4gICAgb25DbGljazogUHJvcFR5cGVzLmZ1bmMsXG4gICAgJ2RhdGEtcWEnOiByZXF1aXJlZElmKFByb3BUeXBlcy5zdHJpbmcsIHByb3BzID0+IHByb3BzLm9uQ2xpY2spLFxuICAgIGRpc2FibGVkOiBQcm9wVHlwZXMuYm9vbFxuICB9KSxcbiAgd2l0aFByb3BzKCh7IG9uQ2xpY2ssIGRpc2FibGVkIH0pID0+ICh7XG4gICAgZGlzYWJsZWQ6IGRpc2FibGVkID8gZGlzYWJsZWQgOiAhb25DbGlja1xuICB9KSksXG4gIHNldERpc3BsYXlOYW1lKCdDbGlja2FibGUnKSxcbikoVW5zdHlsZWRCdXR0b24pO1xuIl19 */"));

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  onClick: _propTypes.default.func,
  'data-qa': (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    return props.onClick;
  }),
  disabled: _propTypes.default.bool
}), (0, _recompose.withProps)(function (_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled;
  return {
    disabled: disabled ? disabled : !onClick
  };
}), (0, _recompose.setDisplayName)('Clickable'))(UnstyledButton);

exports.default = _default;